import { getTimestamp, OwaDate, userDate } from 'owa-datetime';
import { removeItem, setItem, getItem } from 'owa-local-storage';

export enum A2HSLocalStorageKey {
    LastCustomBannerDismissalTimestamp = 'A2HS_CB_Dismissal',
    LastCustomBannerImpressionTimestamp = 'A2HS_CB_Impression',
}

/**
 * Gets A2HS campaign timestamp stored in the local storage.
 * @param key local storage key.
 */
export const getA2HSCampaignTimestamp = (key: A2HSLocalStorageKey): OwaDate | null => {
    const timestampDeserialized = +getItem(self, key);
    return timestampDeserialized ? userDate(timestampDeserialized) : null;
};

/**
 * Stores A2HS campaign timestamp in the local storage.
 * @param key local storage key.
 * @param value timestamp.
 */
export const storeA2HSCampaignTimestamp = (key: A2HSLocalStorageKey, value: OwaDate) => {
    const timestampSerialized = getTimestamp(value).toString();
    setItem(self, key, timestampSerialized);
};

/**
 * Deletes all A2HS campaign data from the local storage.
 */
export const deleteA2HSCampaignData = () => {
    Object.values(A2HSLocalStorageKey).forEach(localStorageKey =>
        removeItem(self, localStorageKey)
    );
};
